var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 473.68 473.68",
    style: {
      enableBackground: "new 0 0 473.68 473.68"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 236.85,
    cy: 236.85,
    r: 236.83
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#518D51"
    },
    d: "M460.143,157.87H314.218c6.335,50.596,6.376,106.339,0.12,156.999h146.116 c8.526-24.438,13.219-50.682,13.219-78.026C473.677,209.139,468.879,182.573,460.143,157.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4E4E4"
    },
    d: "M314.218,157.87H460.14c-0.026-0.075-0.049-0.138-0.075-0.206 C429.752,72.196,351.785,9.315,258.105,0.969C294.361,20.844,304.947,83.804,314.218,157.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D02027"
    },
    d: "M258.113,472.697c93.848-8.362,171.927-71.46,202.12-157.156c0.079-0.228,0.146-0.453,0.228-0.673 h-146.12C305.145,389.338,294.514,452.743,258.113,472.697z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#589F58"
    },
    d: "M0,236.842c0,27.348,4.693,53.588,13.219,78.026h313.313c6.256-50.66,6.215-106.402-0.12-156.999 H13.534C4.798,182.573,0,209.139,0,236.842z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F4F5"
    },
    d: "M13.608,157.668c-0.026,0.067-0.049,0.131-0.075,0.206h312.879 c-9.27-74.07-32.052-137.029-68.303-156.901C251.097,0.352,244.007,0,236.835,0C133.806,0,46.187,65.798,13.608,157.668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB2727"
    },
    d: "M326.532,314.868H13.219c0.079,0.221,0.15,0.445,0.228,0.673 c32.452,92.102,120.19,158.135,223.387,158.135c7.173,0,14.263-0.351,21.274-0.98C294.514,452.743,317.336,389.338,326.532,314.868z "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBg);
export default __webpack_public_path__ + "static/media/flag-bg.fa3ce6b2b61b4f5be5be37c724dc808d.svg";
export { ForwardRef as ReactComponent };